import * as m from "../../model/model";

import { mapToList } from "../../utils/utils";

export class CCourse {
  json: m.Course;

  constructor(json: m.Course) {
    this.json = json;
  }

  get key() {
    return this.json.uid;
  }
  get name() {
    return this.json.name;
  }
  get uid() {
    return this.json.uid;
  }
  get lessons() {
    return mapToList(this.json.lessons).sort((l1, l2) => l1.order - l2.order);
  }
}
